<script lang="ts" module>
  import { Marked, type MarkedExtension } from 'marked';

  import { executeActionString, isActionString } from '@/teoCore/utility/actionString';
  import { useTeoCore } from '@/utils/teo-context';
</script>

<script lang="ts">
  let {
    markdown,
    extension,
    class: className,
  }: { markdown: string; extension?: MarkedExtension; class?: string } = $props();
  let md2html = $derived(new Marked(extension ?? {}));
  let html = $derived(markdown ? md2html.parse(markdown) : '');

  const core = useTeoCore();

  function handleAction(e: Event) {
    if (!core) return;
    if (e.target instanceof HTMLAnchorElement) {
      const href = e.target.attributes.getNamedItem('href')?.value;
      if (href && isActionString(href)) {
        e.preventDefault();
        e.stopPropagation();
        executeActionString(core, href);
      }
    }
  }

  function handleKeyDown(e: KeyboardEvent) {
    if (e.key === 'Enter' || e.key === ' ') {
      handleAction(e);
    }
  }
</script>

<div
  class={`teo-markdown-text ${className ?? ''}`}
  onclick={handleAction}
  onkeydown={handleKeyDown}
  role="presentation"
>
  <!--eslint-disable-next-line svelte/no-at-html-tags-->
  {@html html}
</div>
